import { useSession } from "contexts/session-context";
import { useEffect, useState } from "react";

const informationFields = ["firstName", "lastName", "nickName", "phoneNumber", "email", "birthday", "address", "interests", "genreId"]
const addressFields = ["neighborhood", "postalCode", "city", "state", "country", "street1", "streetNumber", "curp"]
const notAvailableFields = THEME_CONFIG?.notAvailableFields || []

const UsePercentageProfile = () => {
  const [{ user }] = useSession()
  const [percentageProfile, setPercentageProfile] = useState(0)
  const [requiredField, setRequiredFields] = useState<string[]>()
  const total = informationFields.length + addressFields?.length

  const userFieldsCompletedCount = () => {
    const fieldsInfNotCompleted = informationFields?.filter(field => {
      if (notAvailableFields.includes(field)) return false
      return !user[field]
    })
    const fieldsAddressNotCompleted = addressFields?.filter(field => {
      if (notAvailableFields.includes(field)) return false
      if (!user?.address) return true
      return !user?.address[field]
    })
    const fieldsNC = fieldsInfNotCompleted.length + fieldsAddressNotCompleted.length
    return {count : total - fieldsNC, fieldsNull: [...fieldsInfNotCompleted, ...fieldsAddressNotCompleted]}
  }

  useEffect(() => {
    if(!user) return 
    const {count, fieldsNull} = userFieldsCompletedCount()
    setRequiredFields(fieldsNull)
    setPercentageProfile(Math.round((count / total) * 100))
  }, [user])

  return { percentageProfile, requiredField }

}

export default UsePercentageProfile;